
import Vue from 'vue';
export default Vue.extend({
  name: 'Vnodes',
  props: ['nodes'],
  render() {
    return this.nodes;
  }
});
